import { render, staticRenderFns } from "./Tribunales.vue?vue&type=template&id=04c616cc&"
import script from "./Tribunales.vue?vue&type=script&lang=js&"
export * from "./Tribunales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports